import { query, where } from 'firebase/firestore';

import { FSCollections } from '@providers/firestoreProvider';

export const vendorSlotsQuery = (vendorID: string) =>
  query(FSCollections.VendorTimeSlots, where('vendorID', '==', vendorID));
